import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const loginAdmin = createAsyncThunk(
  "/admin/login",
  async ({ id, password }, { rejectWithValue, dispatch }) => {  
    try {
      const response = await api.post("/admin/login", { user_id: id, password });
             console.log("----------------")
        console.log(id)
      dispatch(subscription({ id }));
      sessionStorage.setItem("token", response.data.accessToken); 
      sessionStorage.setItem("refreshToken", response.data.refreshToken);  
      sessionStorage.setItem("admin", JSON.stringify(response.data.admin));  
      dispatch(setAdmin(sessionStorage.admin));

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
}


export const subscription = createAsyncThunk(
  "/admin/subscription",

  async ({ id }, { rejectWithValue, dispatch }) => {  
    try {
      await Notification.requestPermission(); 

      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        throw new Error("Notification permission not granted.");
      }

      // 서비스워커 준비 확인
      const reg = await navigator.serviceWorker.ready;

      // VAPID_PUBLIC_KEY는 base64로 인코딩된 공개키
      const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY; 

      //구독 객체
      const pushSubscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });
      //console.log("PushSubscription object:", pushSubscription.toJSON());
      const { endpoint, keys } = pushSubscription.toJSON();

      const subscriptionData = {
        userID: id,
        endpoint,
        keys_p256dh: keys.p256dh,
        keys_auth: keys.auth,
      };

      // 서버 API 호출
      const response = await api.post("/admin/subscription", subscriptionData);

      return response.data;

    } catch (error) {
      console.error("subscription error:", error);
      return rejectWithValue(error.response?.data || error.message);
    }

  }
);


export const alarmYN = createAsyncThunk(
  "/admin/alarmYN",
  async ({ id }, { rejectWithValue, dispatch }) => {  
    try {
      const response = await api.post("/admin/alarmYN", { user_id: id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const refreshToken = createAsyncThunk(
  "/admin/refresh",
  async (_, { rejectWithValue }) => {
    try {
      const refreshToken = sessionStorage.getItem("refreshToken");
      if (!refreshToken) {
        throw new Error("Refresh token is missing");
      }

      const response = await api.post("/admin/refresh", { refreshToken });
      sessionStorage.setItem("token", response.data.accessToken);  
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const logout = () => (dispatch) => {
  sessionStorage.removeItem("token"); 
  sessionStorage.removeItem("refreshToken"); 
  sessionStorage.removeItem("admin");
  dispatch(clearAdmin());
};

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    admin: JSON.parse(sessionStorage.getItem("admin")) || null,
    loading: false,
    loginError: null,
    registrationError: null,
    success: false,
  },
  reducers: {
    clearErrors: (state) => {
      state.loginError = null;
    },
    setAdmin: (state, action) => {
      state.admin = action.payload; 
    },
    clearAdmin: (state) => {
      state.admin = null; 
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.admin = action.payload.admin; 
        state.loginError = null;
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.loading = false;
        state.loginError = action.payload?.message || "Login failed. Please try again.";
      })
      .addCase(refreshToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(refreshToken.fulfilled, (state) => {
        state.loading = false;
        state.loginError = null;
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.loading = false;
        state.loginError = action.payload?.message || "Token refresh failed.";
      });
  },
});

export const { setAdmin, clearAdmin, clearErrors } = adminSlice.actions;
export default adminSlice.reducer;
